exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config-container[data-v-26fcde68]{padding:20px 10px 30px;max-height:700px;overflow-y:auto;position:relative}.config-container .right-container[data-v-26fcde68]{text-align:center;height:30px}.enum-list[data-v-26fcde68]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.enum-list .enum-item[data-v-26fcde68]{-ms-flex-preferred-size:50%;flex-basis:50%}", ""]);

// exports
